<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div v-if="zakatCaption !== null" class="mt-4 mb-6">
					<h3 class="text-success"><strong>{{ zakatCaption }}</strong></h3>
				</div>

				<form>
					<span class="text-danger text-sm my-6" v-show="errors.has('balance')">{{ errors.first('balance') }}</span>
					<p class="mb-2"><strong>Saldo Tabungan (wajib diisi)</strong></p>
					<vs-input
					    v-model="balance"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahBalance()"
					    v-validate="'required'"
					    dir="rtl"
					    name="balance"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('profit_sharing')">{{ errors.first('profit_sharing') }}</span>
					<p class="mb-2"><strong>Bagi Hasil (jika ada)</strong></p>
					<vs-input
					    v-model="profit_sharing"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahProfitSharing()"
					    dir="rtl"
					    name="profit_sharing"
					/>
					<br>
					<vs-button
					    color="primary"
					    size="large"
					    class="w-full mb-4"
					    @click.prevent="calculateZakat"
					>
					Hitung Zakat
					</vs-button>
					<vs-button
					    color="warning"
					    size="large"
					    type="gradient"
					    class="w-full mb-4"
					    @click.prevent="payZakat"
					>
					<span class="text-dark">Bayar {{ capitalize(type) }}</span>
					</vs-button>	
				</form>
			</vx-card>
		</div>
	</main>
</template>
<script>
import { Validator } from 'vee-validate'
import { minNishabZakat } from '@/assets/utils/zakat'

const dict = {
  custom: {
    balance: {
      required: 'Harap isi saldo tabungan'
    }
  }
}

Validator.localize('en', dict)

export default {
  data: () => ({
    balance: 0,
    type: 'zakat',
    profit_sharing: 0,
    zakatCaption: null
  }),
  methods: {
    toRupiahBalance () {
      this.balance = this.formatRupiah(this.balance)
    },
    toRupiahProfitSharing () {
      this.profit_sharing = this.formatRupiah(this.profit_sharing)
    },
    calculateZakat () {
      this.$validator.validateAll().then(res => {
        if (res) {
          const balance = parseInt(this.balance.toString().replace(/[^0-9-,]/g, '')),
            profit_sharing = parseInt(this.profit_sharing.toString().replace(/[^0-9-,]/g, '')),
            finalResult = minNishabZakat * (balance + profit_sharing)

          this.zakat = finalResult
          this.zakatCaption = `Zakat Simpanan anda Rp ${finalResult}`
        }
      })
    },
    payZakat () {
      this.$emit('payZakat', {total:this.zakat, type: this.type})
    }
  }
}
</script>